module.exports = __webpack_public_path__ + "img/about_us.436b314d.png";